module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-v1-2.b7b79d59.jpg";